<template>
  <v-tooltip color="primary" location="bottom" :disabled="!tooltip">
    <template #activator="{ props: tooltipProps }">
      <v-btn
        variant="text"
        class="sw-header-icon-btn"
        icon
        v-bind="mergedActivatorProps(tooltipProps)"
        :disabled="disabled"
        :loading="loading"
        @click="$emit('click', $event)"
      >
        <v-icon :size="iconSize">{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span v-if="tooltip" class="text-white">{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "SwHeaderIconBtn",
  inheritAttrs: false,
  props: {
    icon: { type: String, default: "mdi-plus" },
    tooltip: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    iconSize: { type: [String, Number], default: undefined },
    /** Merge menu/dialog activator props (e.g. v-menu #activator) */
    activatorProps: { type: Object, default: () => ({}) },
  },
  emits: ["click"],
  methods: {
    mergedActivatorProps(tooltipProps) {
      return { ...tooltipProps, ...this.activatorProps, ...this.$attrs };
    },
  },
};
</script>
